import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const TrustStats = lazy(() => import('./components/sections/TrustStats').then(mod => ({
  default: mod.TrustStats
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const MaterialGallery = lazy(() => import('./components/sections/MaterialGallery').then(mod => ({
  default: mod.MaterialGallery
})));
const TestimonialCarousel = lazy(() => import('./components/sections/TestimonialCarousel').then(mod => ({
  default: mod.TestimonialCarousel
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const BonusesDetail = lazy(() => import('./components/sections/BonusesDetail').then(mod => ({
  default: mod.BonusesDetail
})));
const AboutAuthor = lazy(() => import('./components/sections/AboutAuthor').then(mod => ({
  default: mod.AboutAuthor
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="d2l7x3bfc30u">
      <div className="w-full min-h-full bg-bg-primary font-body text-white" data-id="element-1" data-mp="851h73xjhxs0">
        <main data-id="element-2" data-mp="3gle9siuub3f6">
          <Hero data-id="element-3" data-mp="3gkv2rx6q9zfx" />
          <Suspense fallback={null} data-id="element-4" data-mp="3gmfwjkl7xecq">
            <TrustStats data-id="element-5" data-mp="3gja7248ogagh" />
            <Transformation data-id="element-6" data-mp="3bmbazg5gdtfn" />
            <Method data-id="element-7" data-mp="3bncpjulogy24" />
            <ForYou data-id="element-8" data-mp="3bnuudfmeokln" />
            <MaterialGallery data-id="element-9" data-mp="3bk720jsp648i" />
            <TestimonialCarousel data-id="element-10" data-mp="3qaxulu2457co" />
            <WhatYouGet data-id="element-11" data-mp="3qbze8mx73260" />
            <InstantAccess data-id="element-12" data-mp="3qdaisoygsdy6" />
            <BonusesDetail data-id="element-13" data-mp="3lkr5lt3ovktw" />
            <AboutAuthor data-id="element-14" data-mp="3ljg2zwlzcj4d" />
            <Pricing data-id="element-15" data-mp="3liwgs3par8kj" />
            <Guarantee data-id="element-16" data-mp="3limsckjwh9gy" />
            <FAQ data-id="element-17" data-mp="2xun01g6xxb09" />
            <FinalCTA data-id="element-18" data-mp="2xu3n6dw5dct3" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="2xsk5qjyr8vpq">
          <Footer data-id="element-20" data-mp="2swliizp5xjqw" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="2svjxq3ichivz" />
      </div>
    </LazyMotion>;
}